import React, { useEffect, useState } from "react";
import { NavbarGeneral } from "../componentes/navbarGeneral";
import { CustomFooter } from "../componentes/footer";
import { BotonWhatsappFlotante } from "../componentes/botonWhatsappFlotante";
import { FranjaFija } from "../componentes/franjaFija";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button, Form, Row, Col, Input } from "antd";
import { InputHome } from "../componentes/inputHome";
import { manejarError } from "../manejo_errores";
import Turnstile from "react-turnstile"; 
import ModalAlerta from "../componentes/modalAlerta";
import { PreguntasFrecuentes, ANIMACIONES_FAQ } from "../componentes/preguntasFrecuentes";
import { useAnimacionesAlScroll } from "../useAnimacionesAlScroll";

// Colores de los costados de cada sección cuando la pantalla es más ancha que 1280 px (sacados de los bordes de las imágenes de fondo)
const BORDES = {
  heroIzq: "linear-gradient(180deg, #1E394C 0%, #233B4D 20%, #20394B 40%, #122D41 60%, #163043 80%, #1C364A 100%)",
  acercaIzq: "linear-gradient(180deg, #BBD7F1 0%, #BBD8F2 20%, #89BEE7 40%, #62ABE2 60%, #39566E 80%, #6AAAE4 100%)",
  funcIzq: "linear-gradient(180deg, #455C5A 0%, #1F2C29 20%, #080B08 40%, #090C08 60%, #040704 80%, #050705 100%)",
  funcDer: "linear-gradient(180deg, #445958 0%, #182220 20%, #050806 40%, #060905 60%, #0D100B 80%, #100F0C 100%)",
  contactoIzq: "#091B32", // igual que el panel azul de la sección (rgba(7,26,51,0.93) sobre la foto)
  contactoDer: "linear-gradient(180deg, #060603 0%, #171A01 20%, #1A1E01 40%, #0E0F03 60%, #0A0B02 80%, #181817 100%)",
};
// Animaciones de entrada del home (ver useAnimacionesAlScroll). Las tarjetas de asociaciones se cargan después
// desde la API, por eso se anima la grilla completa y no cada tarjeta
const ANIMACIONES_HOME = [
  { selector: ".contInicio .titulos, .contInicio .titulos-secundarios, .contInicio .contStore", tipo: "izq", escalonar: true },
  { selector: ".contCollage", tipo: "subir" },
  { selector: ".acercaImg", tipo: "izq" },
  { selector: ".acercaPanel", tipo: "subir" },
  { selector: ".funcEtiqueta, .funcTitulo", tipo: "izq", escalonar: true },
  { selector: ".funcGrid .funcCard", tipo: "subir", escalonar: 2 },
  { selector: ".asocEtiqueta, .asocTitulo, .asocSubtitulo", tipo: "izq", escalonar: 3 },
  { selector: ".asocGrid", tipo: "subir" },
  ...ANIMACIONES_FAQ,
  { selector: ".contTexto, .contForm", tipo: "subir", escalonar: true },
];

export const Home = ({ setAlerta }) => {
  useAnimacionesAlScroll(ANIMACIONES_HOME);

  const manejarAlertas = (tipo,mensaje ) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const [asociaciones, setAsociaciones] = useState([]);
  const [formulario, setFormulario] = useState({
    nombre: "",
    asociacion: "",
    email: "",
    mensaje: "",
  })
  const [logo, setLogo] = useState([]);
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaKey, setCaptchaKey] = useState(Date.now());
  const [modalAlerta, setModalAlerta] = useState({
    open: false,
    tipo: null,
    mensaje: ""
  });
  const navigate = useNavigate();

  // Cargar la lista de asociaciones públicas
  useEffect(() => {
    const fetchAsociaciones = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_DOMINIO}/asociaciones-publicas`
        );
        if (response.status === 200) {
          setAsociaciones(response.data);
          setLogo(response.data.imagen || []);
        }
      } catch (error) {
        console.error("Error al obtener las asociaciones:", error);
      }
    };

    fetchAsociaciones();
  }, []);

  const abrirModalConTipo = (tipo, mensaje = "") => {
    setModalAlerta({
      open: true,
      tipo: tipo,
      mensaje: mensaje,
    });
  };


  const cerrarModal = () => {
    setModalAlerta({
      open: false,
      tipo: null,
    });
  };

  const creacionEmail = async () => {
    if (!captchaToken) {
      abrirModalConTipo("errorCaptcha");
      return;
    }

    try {
      const url = `${process.env.REACT_APP_DOMINIO}/form-email`;

      const response = await axios.post(url, {
        ...formulario,
        captchaToken,
      });

      if (response.status === 200) {
        // manejarAlertas("success","Enviado exitosamente")
        abrirModalConTipo("exito");
        
        setFormulario({
          nombre: "",
          asociacion: "",
          email: "",
          mensaje: "",
        });
      }

      setCaptchaToken(""); 
      setCaptchaKey(Date.now());
    } catch (error) {
      // manejarAlertas("error",manejarError(error)) 
      const mensajeDeError = manejarError(error);
      abrirModalConTipo("error", mensajeDeError);
      setCaptchaToken(""); 
      setCaptchaKey(Date.now());
    };
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormulario((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const funcionalidades = [
    { titulo: "Gestión de asociaciones", texto: "Creá y administrá fechas, categorías y horarios con total flexibilidad y desde cualquier dispositivo." },
    { titulo: "App para pilotos", texto: "Registrate, consultá tu historial y seguí resultados desde la app." },
    { titulo: "Carga de resultados", texto: "Ingresá posiciones y clasificaciones en minutos, desde donde estés." },
    { titulo: "Calendario de carreras", texto: "Visualizá todas las carreras programadas según la asociación, categoría o fecha." },
    { titulo: "Acceso por asociación", texto: "Cada entidad tiene su propio espacio dentro del sistema, con ingreso personalizado." },
    { titulo: "Multidisciplina", texto: "Mundo Piloto funciona para autos, motos, kartings y todo tipo de competencia motora." },
  ];

  const decoracionesFuncionalidades = [
    { src: "/img/func-deco-4.png", left: "57.5%", top: "21.3%", width: "4.6%" },
    { src: "/img/func-deco-2.png", left: "9.3%", top: "38.3%", width: "10.3%" },
    { src: "/img/func-deco-3.png", left: "53.8%", top: "50.3%", width: "5.6%" },
    { src: "/img/func-deco-azul.png", left: "20.3%", top: "66%", width: "5%" },
    { src: "/img/func-deco-5.png", left: "87%", top: "70%", width: "7%" },
    { src: "/img/func-deco-1.png", left: "17.4%", top: "90%", width: "11.5%" },
    { src: "/img/func-deco-azul.png", left: "70%", top: "90%", width: "18%" },
  ];

  // copiar: al hacer clic se copia ese texto al portapapeles; href: al hacer clic abre ese enlace
  const datosContacto = [
    { icono: "/img/contacto-ico-mail.png", texto: "info@mundopiloto.com.ar", copiar: "info@mundopiloto.com.ar" },
    { icono: "/img/contacto-ico-telefono.png", texto: "+54 9 2396 41-6909", href: "https://wa.me/5492396416909" },
  ];

  const copiarAlPortapapeles = async (texto) => {
    try {
      await navigator.clipboard.writeText(texto);
    } catch (error) {
      // navegadores sin permiso para el portapapeles: se copia con un campo de texto temporal
      const campo = document.createElement("textarea");
      campo.value = texto;
      campo.style.position = "fixed";
      campo.style.opacity = "0";
      document.body.appendChild(campo);
      campo.select();
      try {
        document.execCommand("copy");
      } catch (e) {
        manejarAlertas("error", "No se pudo copiar el email");
        return;
      } finally {
        document.body.removeChild(campo);
      }
    }
    manejarAlertas("success", "Email copiado al portapapeles");
  };

  // Posiciones en cqw (1cqw = 1% del ancho de la sección de contacto), medidas del diseño de Figma
  const decoracionesContactoAzul = [
    { n: 55, left: 15, top: 0, width: 18 },
    { n: 54, left: 36, top: 0, width: 13.8 },
    { n: 39, left: 46, top: -3, width: 18.3 },
    { n: 57, left: 6, bottom: -12, width: 20 },
    { n: 38, left: 27, bottom: -3, width: 12.5 },
    { n: 48, left: 45.9, top: 22.6, width: 4.1 },
    { n: 50, left: 1.1, top: 9.6, width: 4.1 },
    { n: 44, left: 41.6, top: 9.3, width: 4 },
  ];

  const decoracionesContactoRojo = [
    { n: 49, left: 44.5, top: 2.1, width: 6 },
    { n: 45, left: 26, top: 8, width: 3.1 },
    { n: 46, left: 34.2, top: 29.2, width: 3.5 },
    { n: 47, left: 2.1, top: 30.2, width: 3.5 },
    { n: 61, left: 46, top: 0, width: 9.2 },
    { n: 40, left: 57.6, top: 0, width: 6.6 },
    { n: 59, left: 64, top: 0, width: 7.4 },
    { n: 62, left: 89.7, top: 0, width: 7.9 },
    { n: 56, left: 32, bottom: 0, width: 11 },
    { n: 58, left: 42.5, bottom: 0, width: 10.7 },
    { n: 63, left: 85.4, bottom: 0, width: 5.4 },
    { n: 60, left: 1, bottom: 0, width: 5.8 },
    { n: 53, left: 22, bottom: 0, width: 8 },
  ];

  return (
    <>
      <NavbarGeneral />

      <FranjaFija izq={BORDES.heroIzq} der="#05192A" lineaAbajo="5px solid #D7192E">
      <section
        id="inicio"
        className="heroSec"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "20px",
          justifyContent: "flex-start",
          position: "relative",
          height: "auto",
          backgroundImage: "url('/img/hero-fondo-recorte.png')",
          backgroundSize: "cover",
          backgroundPosition: "left top",
          backgroundRepeat: "no-repeat",
          aspectRatio: "1280 / 689",
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        {/* Contenedor para los títulos */}
        <div
        className="contInicio"
        style={{ textAlign: "center", margin: "0 0 0 4%", width: "38%", justifyContent:"flex-start", alignSelf: "flex-start", marginTop: "7%" }}>
          <h1
            className="titulos"
            style={{
              fontFamily: "'Special Gothic Expanded One', sans-serif",
              fontWeight: 400,
              fontSize: "clamp(1.5rem, 3vw, 38.4px)",
              lineHeight: 1.15,
              color: "var(--blanco)",
              marginBottom: "20px",
              textAlign: "left",
            }}
          >
            TU COMPETICIÓN
            <br />
            <span style={{ color: "#E8333F" }}>EN TUS MANOS</span>
          </h1>
          <h3
            className="titulos-secundarios"
            style={{ fontSize: "1.3em", fontWeight: 400, color: "var(--blanco)", marginBottom: "30px", textAlign:"left" }}
          >
            Gestioná carreras, pilotos, categorías <br/> y resultados desde un solo lugar.
          </h3>
          <div
          className="contStore"
          style={{  
            display: "flex",
            flexDirection: "row",
            gap: "15px"
          }}>
            <Button 
            style={{ 
              fontSize: "0.8em", 
              fontWeight: "100", 
              padding: "20px 5px", 
              backgroundColor: "#001529", 
              color: "#fff", 
              width: 180, 
              height: 70, 
              borderColor: "#001529",
            }}>
              <a href="https://play.google.com/store/apps/details?id=com.tczonal.AppPilotosTcZonal" target="_blank">
                <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "8px"
                }}>
                Disponible en
                <img 
                  src="/img/play-store.svg"
                  alt="playstore"
                  style={{
                    width: "70%",      
                    maxWidth: "150px",  
                    height: "auto",     
                  }}
                />
                </div>
              </a>
            </Button>
            <Button 
            style={{ 
              fontSize: "0.8em", 
              fontWeight: "100", 
              padding: "20px 5px", 
              backgroundColor: "#001529", 
              color: "#fff", 
              width: 180, 
              height: 70, 
              borderColor: "#001529",
            }}>
              <a href="https://apps.apple.com/app/id6744618474" target="_blank">
                <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  gap: "8px"
                }}>
                Disponible en
                <img 
                  src="/img/app-store.svg"
                  alt="appstore"
                  style={{
                    width: "80%",      
                    maxWidth: "150px",  
                    height: "auto",     
                  }}
                />
                </div>
              </a>
            </Button>
          </div>
        </div>
        <div
        className="contCollage"
        style={{ position: "absolute", top: 0, right: 0, width: "66.5%", height: "100%", overflow: "hidden", pointerEvents: "none" }}>
        <img
          src="/img/hero-collage.png"
          alt="Autos, motos y karting de competición"
          style={{
            width: "105.9%",
            maxWidth: "none",
            height: "auto",
            display: "block",
          }}
        />
        </div>
      </section>
      </FranjaFija>
      <FranjaFija izq={BORDES.acercaIzq} der="#DADBDC" lineaAbajo="5px solid #D7192E">
      <section
        id="acerca-de"
        className="acercaSec"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          width: "100%",
          margin: 0,
        }}
      >
        <img
          className="acercaImg"
          src="/img/acerca-bandera.png"
          alt="Bandera a cuadros"
          style={{
            width: "38%",
            height: "auto",
            objectFit: "cover",
            display: "block",
            clipPath: "inset(0 1px 0 0)",
          }}
        />
        <div
          className="acercaPanel"
          style={{
            flex: 1,
            position: "relative",
            backgroundColor: "#DADBDC",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: "4% 5% 4% 3.5%",
          }}
        >
          <div
            className="acercaLabel"
            style={{
              position: "absolute",
              top: "7%",
              right: "5%",
              display: "flex",
              alignItems: "center",
              gap: "24px",
            }}
          >
            <span style={{ width: 40, height: 6, backgroundColor: "#E8333F", display: "block" }} />
            <span
              style={{
                fontFamily: "'Russo One', sans-serif",
                fontSize: "clamp(0.8rem, 1.15vw, 14.7px)",
                color: "#E8333F",
              }}
            >
              MUNDO PILOTO
            </span>
          </div>
          <h2
            style={{
              fontFamily: "'Russo One', sans-serif",
              fontWeight: 400,
              fontSize: "clamp(1.2rem, 2.4vw, 30.7px)",
              lineHeight: 1.2,
              color: "#0B2545",
              marginBottom: "25px",
            }}
          >
            LA HERRAMIENTA PARA ADMINISTRAR
            <br />
            COMPETENCIAS CON PRECISIÓN
          </h2>
          <p style={{ fontSize: "1em", color: "#1B1B1B" }}>
            Mundo Piloto es una plataforma digital creada para facilitar la gestión de competencias, pilotos y resultados en el
            mundo del automovilismo. Desde una misma herramienta, asociaciones, clubes y organizadores pueden administrar
            disciplinas, cargar inscripciones, llevar estadísticas y comunicar información clave de manera ágil y en tiempo real.
            <br /> <br />
            100% online, accesible desde cualquier dispositivo y pensada para hacer más simple lo que antes llevaba horas.
            <br /> <br />
            Con la app de Mundo Piloto, los corredores pueden registrarse, consultar fechas, seguir sus resultados e inscribirse a las carreras, todo desde el celular.
          </p>
        </div>
      </section>
      </FranjaFija>
      <FranjaFija izq={BORDES.funcIzq} der={BORDES.funcDer} lineaAbajo="5px solid #D7192E">
      <section
        id="funcionalidades"
        className="funcSec"
        style={{
          position: "relative",
          overflow: "hidden",
          flexShrink: 0,
          width: "100%",
          aspectRatio: "1 / 1.16",
          boxSizing: "border-box",
          padding: "6.7% 1.8% 8% 7%",
          backgroundImage: "url('/img/func-fondo.png')",
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Formas decorativas (posiciones en % del ancho/alto de la sección) */}
        {decoracionesFuncionalidades.map((deco) => (
          <img
            key={`${deco.src}-${deco.left}`}
            className="funcDeco"
            src={deco.src}
            alt=""
            style={{
              position: "absolute",
              left: deco.left,
              top: deco.top,
              width: deco.width,
              height: "auto",
              pointerEvents: "none",
            }}
          />
        ))}
        <div
          className="funcEtiqueta"
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            gap: "min(3.6vw, 46.1px)",
            width: "fit-content",
            height: "min(2.9vw, 37.1px)",
            minHeight: 28,
            boxSizing: "border-box",
            padding: "0 min(0.6vw, 7.7px)",
            backgroundColor: "#fff",
            margin: "0 0 min(5.8vw, 74.2px) -5.7%",
          }}
        >
          <span
            className="funcBarra"
            style={{ width: "min(3.6vw, 46.1px)", height: "max(4px, min(0.6vw, 7.7px))", backgroundColor: "#E8333F", display: "block", flexShrink: 0 }}
          />
          <span
            style={{
              fontFamily: "'Russo One', sans-serif",
              fontSize: "clamp(0.65rem, 1.2vw, 15.4px)",
              color: "#E8333F",
              whiteSpace: "nowrap",
            }}
          >
            FUNCIONALIDADES
          </span>
        </div>
        <h2
          className="funcTitulo"
          style={{
            position: "relative",
            fontFamily: "'Russo One', sans-serif",
            fontWeight: 400,
            fontSize: "clamp(1.4rem, 3.2vw, 41px)",
            lineHeight: 1.2,
            color: "#fff",
            margin: "0 0 min(6.2vw, 79.4px) -2.7%",
          }}
        >
          TODO LO QUE PODES HACER
        </h2>
        <div
          className="funcGrid"
          style={{
            position: "relative",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            columnGap: "7.9%",
            rowGap: "min(5.6vw, 71.7px)",
            alignItems: "start",
          }}
        >
          {funcionalidades.map((func, i) => (
            <div
              key={func.titulo}
              className={`funcCard ${i % 2 === 1 ? "funcCardDer" : ""}`}
              style={{
                containerType: "inline-size",
                aspectRatio: "326 / 124",
                boxSizing: "border-box",
                padding: "3.7% 4.3% 3% 10.4%",
                backgroundImage: "url('/img/func-card.png')",
                backgroundSize: "100% 100%",
                backgroundRepeat: "no-repeat",
                marginTop: i % 2 === 1 ? "19%" : 0,
              }}
            >
              <div
                className="funcLabel"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6%",
                  aspectRatio: "278 / 32",
                  padding: "0 0 0 4.3%",
                  backgroundImage: "url('/img/func-label.png')",
                  backgroundSize: "100% 100%",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <img src="/img/func-icono.png" alt="" style={{ width: "12.6%", height: "auto" }} />
                <span
                  style={{
                    fontFamily: "'Russo One', sans-serif",
                    fontSize: "4.5cqw",
                    color: "#0B2545",
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                  }}
                >
                  {func.titulo}
                </span>
              </div>
              <p
                className="funcTexto"
                style={{
                  margin: "3.4cqw 9cqw 0 2.6%",
                  color: "#fff",
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "3.8cqw",
                  lineHeight: 1.3,
                }}
              >
                {func.texto}
              </p>
            </div>
          ))}
        </div>
      </section>
      </FranjaFija>
      <FranjaFija izq="#DADBDC">
      <section
        id="asociaciones"
        className="asocSec"
        style={{
          position: "relative",
          overflow: "hidden",
          flexShrink: 0,
          containerType: "inline-size",
          width: "100%",
          aspectRatio: "100 / 85",
          boxSizing: "border-box",
          padding: "5.3% 0 min(3vw, 38.4px)",
          backgroundColor: "#DADBDC",
        }}
      >
        {/* Franjas y foto decorativas */}
        <img
          className="asocDeco"
          src="/img/asoc-franja-corte.png"
          alt=""
          style={{ position: "absolute", right: 0, bottom: "35.4cqw", width: "10.6%", height: "auto", pointerEvents: "none" }}
        />
        {/* Foto y franja en una misma caja, con el mismo alto exacto, para que queden pegadas */}
        <div
          className="asocDeco"
          style={{ position: "absolute", right: 0, bottom: "-4.4cqw", width: "58.2%", height: "40.38cqw", pointerEvents: "none" }}
        >
          <img
            src="/img/asoc-foto.png"
            alt=""
            style={{ position: "absolute", right: 0, top: 0, width: "84.2%", height: "100%" }}
          />
          <img
            src="/img/asoc-franja.png"
            alt=""
            style={{ position: "absolute", left: 0, top: 0, width: "50.4%", height: "100%" }}
          />
        </div>
        <div style={{ position: "relative" }}>
          <div
            className="asocEtiqueta"
            style={{ display: "flex", alignItems: "center", gap: "min(3.6vw, 46.1px)", margin: "0 0 0 1.8%" }}
          >
            <span
              className="asocBarra"
              style={{ width: "min(3.6vw, 46.1px)", height: "max(4px, min(0.6vw, 7.7px))", backgroundColor: "#E8333F", display: "block", flexShrink: 0 }}
            />
            <span
              style={{
                fontFamily: "'Russo One', sans-serif",
                fontSize: "clamp(0.65rem, 1.2vw, 15.4px)",
                color: "#E8333F",
              }}
            >
              ASOCIACIONES
            </span>
          </div>
          <h2
            className="asocTitulo"
            style={{
              fontFamily: "'Russo One', sans-serif",
              fontWeight: 400,
              fontSize: "clamp(1.2rem, 2.7vw, 34.6px)",
              lineHeight: 1.38,
              color: "#0B2545",
              margin: "min(2.9vw, 37.1px) 0 0 3.7%",
            }}
          >
            UNA PLATAFORMA
            <br />
            MUCHAS DISCIPLINAS
          </h2>
          <p
            className="asocSubtitulo"
            style={{
              fontFamily: "'Inter', sans-serif",
              fontWeight: 700,
              fontSize: "clamp(0.6rem, 1vw, 12.8px)",
              color: "#0B2545",
              margin: "min(1vw, 12.8px) 0 min(2.4vw, 30.7px) 3.7%",
            }}
          >
            KARTING - RALLY - TURISMO - MOTOCICLISMO
          </p>
          <div
            translate="no"
            className="notranslate asocGrid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "min(3.4vw, 43.5px)",
              width: "79.2%",
              margin: "0 0 0 10.4%",
            }}
          >
            {asociaciones.map((asociacion) => (
              <div
                key={asociacion.id}
                className="asocCard"
                role="button"
                tabIndex={0}
                onClick={() => navigate(`/${asociacion.siglas}`)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") navigate(`/${asociacion.siglas}`);
                }}
                style={{
                  containerType: "inline-size",
                  display: "flex",
                  flexDirection: "column",
                  aspectRatio: "150 / 132",
                  backgroundColor: "#fff",
                  border: "1px solid #E8333F",
                  borderRadius: "min(2.9vw, 37.1px)",
                  overflow: "hidden",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-end",
                    padding: "6cqw 6cqw 0",
                  }}
                >
                  <img
                    src={
                      asociacion.imagen
                        ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${asociacion.id}/IMAGENES/ASOCIACIONES/${asociacion.imagen}`
                        : "/img/default-asociacion.svg"
                    }
                    alt="Logo"
                    style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                  />
                </div>
                <div
                  className="asocBase"
                  style={{
                    minHeight: "22cqw",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "1cqw 12cqw",
                    textAlign: "center",
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "4.7cqw",
                    lineHeight: 1.25,
                    color: "#fff",
                    backgroundColor: "#E31C25",
                    backgroundSize: "100% 100%",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  {asociacion.nombre} ({asociacion.siglas})
                </div>
              </div>
            ))}
          </div>
          <h2
            className="asocTitulo"
            style={{
              fontFamily: "'Russo One', sans-serif",
              fontWeight: 400,
              fontSize: "clamp(1.2rem, 2.7vw, 34.6px)",
              lineHeight: 1.38,
              color: "#0B2545",
              margin: "min(4.8vw, 61.4px) 0 0 3.7%",
            }}
          >
            ¿TENES UNA ASOCIACIÓN?
            <br />
            ¡REGISTRALA AHORA!
          </h2>
          <div
            className="asocGrid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "min(3.4vw, 43.5px)",
              width: "79.2%",
              margin: "min(2.4vw, 30.7px) 0 0 10.4%",
            }}
          >
            <a
              className="asocCard"
              href="https://wa.me/5492396416909"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                containerType: "inline-size",
                display: "flex",
                flexDirection: "column",
                aspectRatio: "150 / 132",
                backgroundColor: "#F5F5F5",
                border: "1px dashed #B5B5B5",
                borderRadius: "min(2.9vw, 37.1px)",
                overflow: "hidden",
                cursor: "pointer",
                textDecoration: "none",
              }}
            >
              <div style={{ flex: 1, minHeight: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <span style={{ position: "relative", width: "40cqw", height: "40cqw", display: "block" }}>
                  <span style={{ position: "absolute", left: 0, right: 0, top: "50%", height: 1.5, backgroundColor: "#222" }} />
                  <span style={{ position: "absolute", top: 0, bottom: 0, left: "50%", width: 1.5, backgroundColor: "#222" }} />
                </span>
              </div>
              <div
                className="asocBase"
                style={{
                  minHeight: "22cqw",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "1cqw 12cqw",
                  textAlign: "center",
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "4.7cqw",
                  lineHeight: 1.25,
                  color: "#fff",
                  backgroundColor: "#E31C25",
                  backgroundSize: "100% 100%",
                  backgroundRepeat: "no-repeat",
                }}
              >
                ¿Querés añadir tu asociación?
              </div>
            </a>
          </div>
        </div>
      </section>
      </FranjaFija>
      <FranjaFija izq="#EFEFEF" lineaArriba="3px solid #E31C25">
        <PreguntasFrecuentes />
      </FranjaFija>
      <FranjaFija izq={BORDES.contactoIzq} der={BORDES.contactoDer} lineaArriba="3px solid #E31C25" lineaAbajo="3px solid #E31C25">
      <section
        id="contacto"
        className="contSec"
        style={{
          position: "relative",
          overflow: "hidden",
          flexShrink: 0,
          containerType: "inline-size",
          width: "100%",
          aspectRatio: "1280 / 562",
          boxSizing: "border-box",
          backgroundImage: "url('/img/contacto-fondo.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Panel azul oscuro con borde inclinado; las formas azules van adentro para que el borde las recorte */}
        <div
          className="contPanel"
          style={{
            position: "absolute",
            inset: 0,
            clipPath: "polygon(0 0, 65.8% 0, 43.8% 100%, 0 100%)",
            backgroundColor: "rgba(7, 26, 51, 0.93)",
          }}
        >
          {decoracionesContactoAzul.map((deco) => (
            <img
              key={deco.n}
              className="contDeco"
              src={`/img/contacto-d${deco.n}.png`}
              alt=""
              style={{
                position: "absolute",
                left: `${deco.left}cqw`,
                top: deco.top !== undefined ? `${deco.top}cqw` : "auto",
                bottom: deco.bottom !== undefined ? `${deco.bottom}cqw` : "auto",
                width: `${deco.width}cqw`,
                height: "auto",
                pointerEvents: "none",
              }}
            />
          ))}
        </div>
        {decoracionesContactoRojo.map((deco) => (
          <img
            key={deco.n}
            className="contDeco"
            src={`/img/contacto-d${deco.n}.png`}
            alt=""
            style={{
              position: "absolute",
              left: `${deco.left}cqw`,
              top: deco.top !== undefined ? `${deco.top}cqw` : "auto",
              bottom: deco.bottom !== undefined ? `${deco.bottom}cqw` : "auto",
              width: `${deco.width}cqw`,
              height: "auto",
              pointerEvents: "none",
            }}
          />
        ))}
        <div className="contTexto" style={{ position: "absolute", left: "1.4cqw", top: "5.7cqw" }}>
          <div
            className="contEtiqueta"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "3.6cqw",
              width: "fit-content",
              height: "2.7cqw",
              minHeight: 28,
              boxSizing: "border-box",
              padding: "0 0.6cqw",
              backgroundColor: "#fff",
            }}
          >
            <span
              className="contBarra"
              style={{ width: "3.6cqw", height: "max(4px, 0.55cqw)", backgroundColor: "#E8333F", display: "block", flexShrink: 0 }}
            />
            <span
              style={{
                fontFamily: "'Russo One', sans-serif",
                fontSize: "max(0.65rem, 1.2cqw)",
                color: "#E8333F",
                whiteSpace: "nowrap",
              }}
            >
              CONTACTO
            </span>
          </div>
          <h2
            className="contTitulo"
            style={{
              fontFamily: "'Russo One', sans-serif",
              fontWeight: 400,
              fontSize: "3.1cqw",
              lineHeight: 1.31,
              color: "#fff",
              margin: "3.7cqw 0 0 2.5cqw",
            }}
          >
            ¿BUSCÁS MAS INFO?
            <br />
            <span style={{ color: "#E8333F" }}>¡HABLEMOS!</span>
          </h2>
          <p
            className="contSubtitulo"
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: "1.65cqw",
              lineHeight: 1.47,
              color: "#fff",
              margin: "3.1cqw 0 0 2.5cqw",
            }}
          >
            Hablemos sobre tu asociación, competencia o
            <br />
            categoría y te ayudamos con Mundo Piloto
          </p>
          <div
            className="contDatos"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1.1cqw",
              width: "fit-content",
              height: "3.8cqw",
              padding: "0 1.2cqw",
              borderRadius: "0.4cqw",
              backgroundColor: "rgba(0, 0, 0, 0.55)",
              margin: "3.7cqw 0 0 2.5cqw",
            }}
          >
            {datosContacto.map((dato, i) => (
              <React.Fragment key={dato.texto}>
                {i > 0 && (
                  <span
                    className="contSeparador"
                    style={{ width: 1, height: "1.7cqw", backgroundColor: "rgba(255, 255, 255, 0.35)" }}
                  />
                )}
                {(() => {
                  const contenido = (
                    <>
                      <img src={dato.icono} alt="" style={{ width: "1.15cqw", height: "auto" }} />
                      <span
                        style={{
                          fontFamily: "'Inter', sans-serif",
                          fontWeight: 600,
                          fontSize: "max(0.6rem, 0.95cqw)",
                          color: "#fff",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {dato.texto}
                      </span>
                    </>
                  );
                  const estilo = {
                    display: "flex",
                    alignItems: "center",
                    gap: "0.6cqw",
                    padding: 0,
                    border: 0,
                    background: "none",
                    cursor: "pointer",
                    textDecoration: "none",
                  };
                  return dato.href ? (
                    <a
                      href={dato.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={estilo}
                      aria-label={`${dato.texto} (abre WhatsApp)`}
                    >
                      {contenido}
                    </a>
                  ) : (
                    <button
                      type="button"
                      onClick={() => copiarAlPortapapeles(dato.copiar)}
                      style={estilo}
                      title="Copiar email"
                      aria-label={`Copiar ${dato.texto}`}
                    >
                      {contenido}
                    </button>
                  );
                })()}
              </React.Fragment>
            ))}
          </div>
        </div>
        <div
          className="contForm"
          style={{
            position: "absolute",
            left: "66cqw",
            top: "50%",
            transform: "translateY(-50%)",
            width: "31.5cqw",
            boxSizing: "border-box",
            padding: "2.5cqw 2.8cqw",
            backgroundColor: "#0B2545",
            borderRadius: "1.1cqw",
          }}
        >
          <InputHome
            idCampo="nombre"
            nombreCampo="Nombre"
            tipo="text"
            elValue={formulario.nombre}
            elPlaceholder="Nombre"
            onChange={handleChange}
          />
          <InputHome
            idCampo="asociacion"
            nombreCampo="Asociación"
            tipo="text"
            elValue={formulario.asociacion}
            elPlaceholder="Asociación"
            onChange={handleChange}
          />
          <InputHome
            idCampo="email"
            nombreCampo="Email"
            tipo="text"
            elValue={formulario.email}
            elPlaceholder="Email"
            onChange={handleChange}
          />
          <InputHome
            idCampo="mensaje"
            nombreCampo="Mensaje"
            tipo="textarea"
            elValue={formulario.mensaje}
            elPlaceholder="Mensaje"
            onChange={handleChange}
          />
          <div className="contCaptcha" style={{ display: "flex", justifyContent: "center", overflow: "auto", margin: "0.5cqw 0 1cqw" }}>
            <Turnstile
              key={captchaKey}
              sitekey={process.env.REACT_APP_CF_SITE_KEY}
              theme="dark"
              onSuccess={(token) => setCaptchaToken(token)}
            />
          </div>
          <Button
            className="contEnviar"
            onClick={creacionEmail}
            style={{
              width: "100%",
              height: "2.3cqw",
              minHeight: 30,
              fontSize: "max(0.7rem, 0.95cqw)",
              fontFamily: "'Inter', sans-serif",
              backgroundColor: "#E31C25",
              borderColor: "#E31C25",
              borderRadius: "0.25cqw",
              color: "#fff",
            }}
          >
            Enviar
          </Button>
          <ModalAlerta
            open={modalAlerta.open}
            onClose={cerrarModal}
            tipoAlerta={modalAlerta.tipo}
            mensaje={modalAlerta.mensaje}
          />
        </div>
      </section>
      </FranjaFija>

      <CustomFooter />
      <BotonWhatsappFlotante />
    </>
  );
};
